import React, { useState, useEffect } from "react";
import { Radio, Card, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Document from "./Document";
import { fetchDocumentDetails } from "../../Action/Actions";
import { getUserData } from "../login/LoginSlice";
import { selectSelectedYearId } from "../../Redux/financialYearSlice";

const Index = () => {
  const dispatch = useDispatch();
  const AuthData = useSelector(getUserData);
  const selectedYearId = useSelector(selectSelectedYearId); // Get the selected financial year ID
  const [heading, setHeading] = useState("Policy Document");
  const [loading, setLoading] = useState(false);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [documentsData, setDocumentsData] = useState({});
  const [selectedData, setSelectedData] = useState("Policy Document");
  const [activeTab, setActiveTab] = useState(null);

  // Fetch document details on component mount or when financial year changes
  useEffect(() => {
    // Ensure both corporate ID and financial year ID are available
    if (AuthData?.corporate_id && selectedYearId) {
      setLoading(true);
      // The action now implicitly uses the financial year ID from the state
      dispatch(fetchDocumentDetails(AuthData?.corporate_id))
        .then((data) => {
          const { documents } = data;
          setDocumentsData(documents || {});

          // Initialize default data for "Policy Document"
          if (documents && documents["Policy Document"]) {
            const firstTabKey = Object.keys(documents["Policy Document"])[0];
            setActiveTab(firstTabKey);
            const firstPolicy = documents["Policy Document"][firstTabKey]?.[0];
            const hasValidPolicyNumber = firstPolicy?.policy_number && 
              (typeof firstPolicy.policy_number === 'string' ? firstPolicy.policy_number.trim() !== "" : true);
            const initialPolicyKey = hasValidPolicyNumber ? firstPolicy.policy_number : (firstPolicy?.policy_id || `policy-0`);
            setSelectedPolicyNumber(initialPolicyKey);
          } else {
             // Reset state if no documents are found for the selected year
             setActiveTab(null);
             setSelectedPolicyNumber(null);
          }

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          // Clear data on error to avoid showing stale information
          setDocumentsData({}); 
          setActiveTab(null);
          setSelectedPolicyNumber(null);
          console.error("Error fetching document details:", err);
        });
    }
  }, [dispatch, AuthData?.corporate_id, selectedYearId]); // Correctly depends on selectedYearId

  useEffect(() => {
    if (documentsData[selectedData]) {
      const firstTab = Object.keys(documentsData[selectedData])[0];
      setActiveTab(firstTab);
      const firstPolicy = documentsData[selectedData][firstTab]?.[0];
      const hasValidPolicyNumber = firstPolicy?.policy_number && 
        (typeof firstPolicy.policy_number === 'string' ? firstPolicy.policy_number.trim() !== "" : true);
      const initialPolicyKey = hasValidPolicyNumber ? firstPolicy.policy_number : (firstPolicy?.policy_id || `policy-0`);
      setSelectedPolicyNumber(initialPolicyKey);
    } else {
      // If the selected document type doesn't exist, clear the view
      setActiveTab(null);
      setSelectedPolicyNumber(null);
    }
  }, [selectedData, documentsData]);

  const handleStatus = (e) => {
    const value = e.target.value;
    if (value === 0) {
      setHeading("Policy Document");
      setSelectedData("Policy Document");
    } else if (value === 1) {
      setHeading("Service Document");
      setSelectedData("Service Document");
    }
  };

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    const firstPolicy = documentsData[selectedData]?.[newTab]?.[0];
    const hasValidPolicyNumber = firstPolicy?.policy_number && 
      (typeof firstPolicy.policy_number === 'string' ? firstPolicy.policy_number.trim() !== "" : true);
    const policyKey = hasValidPolicyNumber ? firstPolicy.policy_number : (firstPolicy?.policy_id || `policy-0`);
    setSelectedPolicyNumber(policyKey);
  };

  const handlePolicyNumberClick = (policyNumber) => {
    setSelectedPolicyNumber(policyNumber);
  };

  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>
                <Radio.Group
                  block
                  defaultValue={0}
                  optionType="button"
                  buttonStyle="solid"
                  onChange={handleStatus}
                >
                  <Radio value={0}>Policy Document</Radio>
                  <Radio value={1}>Service Document</Radio>
                </Radio.Group>
              </div>
            }
            bordered={false}
          ></Card>

          <Document
            loading={loading}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
            DocumentDetails={documentsData[selectedData]}
            selectedPolicyNumber={selectedPolicyNumber}
            setSelectedPolicyNumber={handlePolicyNumberClick}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Index;